export const dataReducer = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_ENTITY': {
      const { entities } = state
      const { item, position } = action.data
      entities.splice(position, 0, item)

      return {
        ...state,
        entities: entities.slice()
      }
    }
    case 'UPDATE_ENTITY': {
      const { entities } = state
      const { item, position } = action.data
      entities[position] = item

      return {
        ...state,
        entities: entities.slice()
      }
    }
    case 'REORDER_ENTITIES': {
      const { entities, attributes } = state
      const { data } = action
      const { from, to } = data

      const broken = attributes.some(attr => attr.refs.split(',').length < entities.length)

      const item = entities.splice(from, 1)[0]
      entities.splice(to, 0, item)

      return {
        ...state,
        entities: entities.slice(),
        attributes: broken
          ? attributes
          : attributes.map(attr => {
              const refs = attr.refs.split(',').map(v => v.trim())

              const ref = refs.splice(from, 1)[0]
              refs.splice(to, 0, ref)

              return Object.assign(attr, {
                refs: refs.join(', ')
              })
            })
      }
    }
    case 'DELETE_ENTITY': {
      const { entities, attributes, errors } = state

      const broken = attributes.some(attr =>
        0 < attr.refs.trim().length ? attr.refs.split(',').length < entities.length : true
      )

      entities.splice(action.data, 1)

      return {
        ...state,
        entities: entities.slice(),
        attributes: broken
          ? attributes
          : attributes.map(attr => {
              const refs = attr.refs.split(',').map(v => v.trim())
              refs.splice(action.data, 1)

              return Object.assign(attr, {
                refs: refs.join(', ')
              })
            }),
        // action.data is 0-based; error ids are 1-based (e{position}) — drop the deleted row's error and shift survivors above it down by one
        errors: errors
          .filter(v => !('e' == v[0] && Number(v.slice(1)) == action.data + 1))
          .map(v => ('e' == v[0] && Number(v.slice(1)) > action.data + 1 ? `e${Number(v.slice(1)) - 1}` : v))
      }
    }
    case 'ADD_ATTRIBUTE': {
      const { attributes } = state
      const { item, position } = action.data
      attributes.splice(position, 0, item)

      return {
        ...state,
        attributes: attributes.slice()
      }
    }
    case 'UPDATE_ATTRIBUTE': {
      const { attributes } = state
      const { item, position } = action.data
      attributes[position] = item

      return {
        ...state,
        attributes: attributes.slice()
      }
    }
    case 'UPDATE_ATTRIBUTES_METHOD': {
      const { attributes } = state
      const { method } = action.data

      return {
        ...state,
        attributes: attributes.map(attr =>
          Object.assign(attr, {
            method
          })
        )
      }
    }
    case 'REORDER_ATTRIBUTES': {
      const { attributes } = state
      const { from, to } = action.data
      const item = attributes.splice(from, 1)[0]
      attributes.splice(to, 0, item)

      return {
        ...state,
        attributes: attributes.slice()
      }
    }
    case 'DELETE_ATTRIBUTE': {
      const { attributes, errors } = state
      attributes.splice(action.data, 1)

      return {
        ...state,
        attributes: attributes.slice(),
        // action.data is 0-based; error ids are 1-based (a{position}) — drop the deleted row's error and shift survivors above it down by one
        errors: errors
          .filter(v => !('a' == v[0] && Number(v.slice(1)) == action.data + 1))
          .map(v => ('a' == v[0] && Number(v.slice(1)) > action.data + 1 ? `a${Number(v.slice(1)) - 1}` : v))
      }
    }
    case 'ADD_VARIABLE': {
      const { variables } = state
      const { item, position } = action.data
      variables.splice(position, 0, item)

      return {
        ...state,
        variables: variables.slice()
      }
    }
    case 'UPDATE_VARIABLE': {
      const { variables } = state
      const { item, position } = action.data
      variables[position] = item

      return {
        ...state,
        variables: variables.slice()
      }
    }
    case 'REORDER_VARIABLES': {
      const { variables } = state
      const { from, to } = action.data
      const item = variables.splice(from, 1)[0]
      variables.splice(to, 0, item)

      return {
        ...state,
        variables: variables.slice()
      }
    }
    case 'DELETE_VARIABLE': {
      const { variables, errors } = state
      variables.splice(action.data, 1)

      return {
        ...state,
        variables: variables.slice(),
        // action.data is 0-based; error ids are 1-based (v{position}) — drop the deleted row's error and shift survivors above it down by one
        errors: errors
          .filter(v => !('v' == v[0] && Number(v.slice(1)) == action.data + 1))
          .map(v => ('v' == v[0] && Number(v.slice(1)) > action.data + 1 ? `v${Number(v.slice(1)) - 1}` : v))
      }
    }
    case 'UPDATE_REFS': {
      const { refs } = state
      refs[action.data.id] = action.data.refs

      return {
        ...state,
        refs
      }
    }
    case 'UPDATE_ERRORS': {
      const { errors } = state
      const index = errors.indexOf(action.data.id)
      0 <= index && errors.splice(index, 1)
      true == action.data.error && errors.push(action.data.id)

      return {
        ...state,
        errors
      }
    }
    case 'RESET': {
      return {
        ...state,
        ...action.data
      }
    }
    default:
      throw new Error('Unknown action type')
  }
}
